// initial values
const catalog = {
        layoutInitial: { type: null, needSum: null, filter: null },
        list: { arr: [], meta: null },
        activePetsFilters: {
            pet_category_id: [], pet_filter_id: [], city_id: null, only_need_sum: null,
            donations_filter: null, page: 1, pet_age_category_id: [], size: null, gender: null
        },
        activeProjectsFilters: {
            project_category_id: [], city_id: null, donations_filter: null, page: 1, allow_autopay: null
        },
        fetched: false,
        filtersPets: null,
        filtersProjects: null,
        toggleFilter: false,
        totalActivePets: 0,
        search: { citySearch: null, citySelected: null, city_id: null, cities: [] }
};


// state initial function
const getDefaultCatalog = () => ({ ...catalog });

// Catalog state
const state = getDefaultCatalog();


// Catalog state getters
const getters = {

    getterCatalog:  ( state )  =>  state,

    sliceByKey:     ( state )  =>  ( key )  =>  state[ `${key}` ],

}

// Catalog state setters
const mutations = {

    resetCatalog:   ( state )  =>  state = getDefaultCatalog(),

    setterByKey:    ( state, { key, data } )  =>  state[ `${key}` ] = data,

    resetByKey:     ( state, { key, data = null } )  => {

        if( Array.isArray( catalog[`${key}`] ) ||  catalog[`${key}`] === Object( catalog[`${key}`] ) ){
          return state[`${key}`] = key === 'activePetsFilters' ?
                { ...catalog[`${key}`], only_need_sum: state.layoutInitial.needSum ? 1 : 0 } :
                { ...catalog[`${key}`] };
        }

        return state[`${key}`] = catalog[`${key}`];


    },

}

// Catalog state actions
const actions = {

    async searchCities( { commit, getters }, city = null ){
        commit('setterByKey', { key: 'search', data: { ...getters.sliceByKey( 'search' ), citySearch: city } } );

        try{

            const { data: { cities = [], success = false } } = await axios.get( '/geo/searchCities', { params: { searchValue: city } } );

            if( success ){

                let data = getters.sliceByKey( 'search' );
                data = { ...data, cities }

                commit('setterByKey', { key: 'search', data: { ...data } } );
            }

        } catch ( _e ){

            console.log( _e )

        }


    },

    async getList ( { commit, getters, state }, { key = 'activePetsFilters', params = {} } ) {

        const layout = getters.sliceByKey( 'layoutInitial' ),
            url = layout.type  ===  'projects'  ? '/catalog/projects' : layout.needSum ? '/catalog/pets' : '/catalog/seek_home' ,
              gFiltersState = getters.sliceByKey( key );
        const p = { ...gFiltersState, ...params };

        delete p.only_need_sum;


        try{

            const {
                    data: {
                        data = [],
                        extended_data: { success = false },
                        ...rest
                    }
            } = await axios.get( url , { params: p } );

            if( success ){

                setTimeout(() => {
                    commit('setterByKey', { key: 'list', data: { arr: data, meta: rest } } );

                    commit('setterByKey', { key: 'fetched', data: false });
                }, 500 )

            }

        } catch( _e ){

            console.log( _e );

            setTimeout(() => {
                commit('setterByKey', { key: 'fetched', data: false });
            }, 500 )

        }

    },

    async getInitDataForCatalog( { commit }, _type = 'pets' ) {

        try {

            const {
                data: {
                    data:{
                        filters = [],
                        categories = [],
                        ageCategories = [],
                        donationsFilter = [ '<40', '40-80', '>80' ],
                        sizes = {},
                        totalActivePets = 0
                    },
                    success = false
                }
            } = await  axios.get( `/api/catalog/init/${_type}` );

            if( success ){
                commit('setterByKey', { key: 'totalActivePets', data: totalActivePets } );

                if ( _type === 'pets' ) {
                    commit('setterByKey', { key: 'filtersPets', data: { filters, categories, ageCategories, donationsFilter, sizes } } );
                }

                if ( _type === 'projects' ) {
                    commit('setterByKey', { key: 'filtersProjects', data: { filters, categories, donationsFilter } } );
                }

            }


        } catch ( _e ){

            console.log( _e );

        }

    },

}


// export Catalog state
export default {
    state,
    getters,
    mutations,
    actions,
}
